import { TransparentCardDesktopNotSelected } from './TransparentCardDesktopNotSelected'
import { section4Data } from './data/section4Data'
import { TransparentCardDesktopSelected } from './TransparentCardDesktopSelected'
import { useState } from 'react'

export const Section4Desktop = () => {
  const [selectedCard, setSelectedCard] = useState(0)

  const handleCardClick = (index: number) => {
    if (index !== selectedCard) {
      setSelectedCard(index)
    }
  }

  return (
    <div className='py-28 px-20 lg:px-30 xl:px-15 2xl:px-20 3xl:px-30 xl:flex xl:flex-row xl:gap-10 2xl:gap-20 3xl:gap-60 3xl:py-52'>
      <div className='xl:max-w-[280px] 2xl:max-w-[400px]'>
        <h3 className='text-left text-[#EBF3FF] text-lg font-bold leading-6 tracking-[0.4px] mb-6 xl:text-right lg:text-3xl 3xl:text-[40px] 3xl:leading-normal'>
          Our pillars of progress
        </h3>
        <p className='text-left text-[#EBF3FF] text-sm font-normal leading-4 tracking-[0.4px] mb-10 xl:text-right lg:text-base 2xl:text-xl 3xl:leading-8'>
          We have achieved significant progress through our technology,
          leadership, customers and global presence in LawTech since 2017.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 xl:w-full">
        {section4Data.map((item, index) => (
          <div onClick={() => handleCardClick(index)}>
            {selectedCard === index ? (
              <TransparentCardDesktopSelected key={index}
                title={item.title}
                body={item.body}
              />
            ) : (
              <TransparentCardDesktopNotSelected key={index}
                title={item.title}
                body={item.body}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}